<template lang='pug'>
  el-dialog(title="预缴费",width="50%",:visible.sync='viewopen' :modal-append-to-body='true' :append-to-body="true")
    div.feeBox(style="padding-bottom:40px")
      h3 支付方式：
      div(class='erwei')
        img(:src="record.qrImg")
      div(class="moneybox")
        div(class="money") 应付金额：
          span ￥{{record.shallAmount}}元
        p 请使用微信扫描二维码以完成支付
    div.feeBox()
      h3 费用说明：
      div(class="feesm")
        p 1、收取费用按发布时设置的签位数预交费；
        p 2、当手动结束比赛时，根据实时参赛签位进行单次发布结算，多余钱款退回原账户；
        p 3、当取消比赛时，若参赛人员全额退款，此时不收费，钱款全部退还原账户。

    span.dialog-footer(slot="footer" )
        el-button(@click="releaseSubmit" type="primary") 支付完成并发布
        el-button(@click="closezf") 取 消
</template>

<script>
export default{
  props: ['openfee', 'record'],

  data () {
    return {
      viewopen: true
    }
  },
  methods: {
    releaseSubmit () {
      this.viewopen = false
      this.$emit('zfsuccess', 1)
    },
    closezf () {
      this.viewopen = false
      this.$emit('zfsuccess', 0)
    }
  }
}
</script>
<style lang='scss' scoped>
  .feeBox{
    display:flex;
    justify-content: flex-start;
    padding-left:30px;
    h3{
      margin-right: 20px;
    }
    .erwei {
      width: 240px;
      height: 240px;
      img{
        width: 100%;
        height: 100%;
      }

    }
    .moneybox{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 50px;
      .money{

        padding-top:70px;
        font-size: 18px;
        font-weight: 700;
        span{
          font-size: 30px;
          color: rgb(255, 81, 0)
        }
      }
      p{
        font-size: 16px;
        padding-bottom: 15px;
      }
    }
    .feesm{
      height: 200px;
      border: 1px solid #ccc;
      padding: 20px;
    }

  }
</style>
